import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskLectureGroupMemberVm } from '../my-osk-lecture-group-member-vm.model';
@Injectable({ providedIn: 'root' })
export class MyOskLectureGroupMembersService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureGroupMembers`;
  }
  get(lectureGroupGuid: string): Observable<IMyOskLectureGroupMemberVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (lectureGroupGuid !== undefined && lectureGroupGuid !== null) {
      params = params.set('lectureGroupGuid', lectureGroupGuid.toString());
    }
    return this.http.get<IMyOskLectureGroupMemberVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
